
<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 14 14"><g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><path d="M11.5.5h1a1 1 0 0 1 1 1v1m-13 0v-1a1 1 0 0 1 1-1h1m3 0h3m5 5v2.75M.5 5.5v3m0 3v1a1 1 0 0 0 1 1h1m3 0h2.75"></path><circle cx="8" cy="8" r="3.5"></circle><path d="M10.47 10.47L13 13"></path></g></svg>
  </template>
  
  <script>
  export default {
	name: 'MagnifierSquareArea'
  }
  </script>